var _path, _circle, _mask, _g, _mask2, _g2, _path2, _mask3, _g3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetSaturnInternal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 668,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.286 53.283c.112-.12.227-.24.344-.357 28.705-28.705 177.658 73.709 332.696 228.747 155.038 155.038 257.452 303.991 228.747 332.696-.117.117-.236.232-.357.345l-45.524-45.524c.122-.112.242-.227.359-.344 24.05-24.049-61.756-148.848-191.653-278.745C248.001 160.205 123.203 74.399 99.153 98.448a11.51 11.51 0 00-.344.359L53.286 53.283zm56.562 56.563c22.886-22.886 141.637 58.759 265.238 182.36 123.601 123.601 205.246 242.352 182.36 265.238l-17.143-17.143c.123-.111.243-.226.36-.343 21.14-21.14-54.091-130.647-168.033-244.589-113.942-113.942-223.449-189.173-244.589-168.033a11.66 11.66 0 00-.343.36l-17.85-17.85z",
    fill: "#B87D43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 318,
    r: 208,
    fill: "#FCCB6B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 110,
    width: 416,
    height: 416
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 318,
    r: 208,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.369 518.472c-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97l110.308 110.309c4.687 4.686 12.285 4.686 16.971 0s4.686-12.284 0-16.971L540.369 518.472zM384.806 362.908c-4.687-4.686-12.285-4.686-16.971 0s-4.686 12.284 0 16.971l55.154 55.154-.007.007c4.337 4.708 4.222 12.042-.346 16.61-4.568 4.568-11.903 4.683-16.61.346l-.007.008-113.137-113.137c-4.687-4.687-12.284-4.687-16.971 0-4.686 4.686-4.686 12.284 0 16.97l181.727 181.727c4.686 4.686 12.284 4.686 16.97 0 4.687-4.687 4.687-12.285 0-16.971l-34.648-34.648c-4.686-4.687-4.686-12.284 0-16.971 4.686-4.686 12.284-4.686 16.971 0l21.213 21.213c4.686 4.687 12.284 4.687 16.97 0 4.687-4.686 4.687-12.284 0-16.97L384.806 362.908zm77.074 212.839c-4.686-4.686-12.284-4.686-16.97 0-4.687 4.687-4.687 12.285 0 16.971l51.619 51.619c4.686 4.686 12.284 4.686 16.97 0 4.686-4.687 4.686-12.285 0-16.971l-51.619-51.619zM258.941 372.808c-4.687-4.687-12.285-4.687-16.971 0-4.686 4.686-4.686 12.284 0 16.97l51.619 51.619c4.686 4.686 12.284 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.971l-51.618-51.618zM63.779 194.617c4.687-4.687 12.284-4.687 16.97 0l117.38 117.38c4.687 4.686 4.687 12.284 0 16.97-4.686 4.686-12.284 4.686-16.97 0l-117.38-117.38c-4.686-4.686-4.686-12.284 0-16.97zm193.747 74.953c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.686-4.686 12.284 0 16.971l6.364 6.364c4.686 4.686 4.686 12.284 0 16.97-4.686 4.686-12.284 4.686-16.971 0L48.223 128.149c-4.687-4.687-4.687-12.285 0-16.971 4.686-4.686 12.284-4.686 16.97 0L206.615 252.6l.007-.008c4.707 4.337 12.042 4.222 16.61-.346 4.568-4.568 4.683-11.902.346-16.61l.007-.007-16.97-16.971c-4.687-4.686-4.687-12.284 0-16.97 4.686-4.686 12.284-4.686 16.97 0l110.309 110.309c4.686 4.686 4.686 12.284 0 16.97-4.686 4.686-12.284 4.686-16.971 0l-59.397-59.397zM55.294 50.367c4.686-4.686 12.284-4.686 16.97 0l110.309 110.309c4.686 4.686 4.686 12.284 0 16.97-4.686 4.687-12.284 4.687-16.97 0L55.293 67.338c-4.685-4.687-4.685-12.285 0-16.971z",
    fill: "#ECB55A"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 110,
    width: 416,
    height: 416
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 318,
    r: 208,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    fill: "#000",
    d: "M334 110h209.089v416H334z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334 520c111.562 0 202-90.438 202-202s-90.438-202-202-202v404z",
    fill: "#9C4925"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 116,
    width: 202,
    height: 404
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334 520c111.562 0 202-90.438 202-202s-90.438-202-202-202v404z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 318,
    r: 114,
    fill: "#E09B7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.5,
    cy: 318.5,
    r: 34.5,
    fill: "#FEC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.284 53.285a14 14 0 00-.357.345c-28.705 28.704 73.709 177.657 228.747 332.695C436.712 541.363 585.665 643.777 614.37 615.072c.117-.117.232-.236.345-.357l-45.524-45.524c-.112.122-.227.242-.344.359-24.049 24.05-148.848-61.756-278.745-191.653C160.206 248 74.4 123.202 98.449 99.152c.118-.117.237-.232.359-.344L53.284 53.285zm56.563 56.562c-22.886 22.886 58.759 141.637 182.36 265.238 123.601 123.601 242.352 205.246 265.238 182.36l-17.143-17.143a9.717 9.717 0 01-.343.36c-21.14 21.14-130.647-54.091-244.589-168.033C181.428 258.687 106.197 149.18 127.337 128.04c.118-.117.237-.231.36-.343l-17.85-17.85z",
    fill: "#B87D43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetSaturnInternal);
export default __webpack_public_path__ + "static/media/planet-saturn-internal.e883c55958ad2299ab4ea1674cc8382c.svg";
export { ForwardRef as ReactComponent };